import { render } from "./Refills.vue?vue&type=template&id=4ce72b8e"
import script from "./Refills.vue?vue&type=script&lang=js"
export * from "./Refills.vue?vue&type=script&lang=js"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__